import React, {PropsWithChildren} from 'react';
import {FeaturesContext, useEnvFeatures} from 'app/components/entities/cloud';

export function ApplicationFeatures({children}: PropsWithChildren<{}>) {
  const features = useEnvFeatures();
  return <FeaturesContext.Provider value={features}>{children}</FeaturesContext.Provider>;
}
